import React from "react";
import ReactDOM from "react-dom/client";

import { worker as serverWorker } from "@/mocks/browser";
import { PARSED_ENV } from "@/constants/common";
import { initPlausible } from "@/utils/analytics";

import "@/utils/string.extensions";

import App from "./App";

// Initialize Plausible Analytics
initPlausible();

if (PARSED_ENV.VITE_NODE_ENV === "development") {
	serverWorker.start();
}

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

root.render(
	// <React.StrictMode>
	<App />
	// </React.StrictMode>
);
